module.exports = __webpack_public_path__ + "img/dep_alcoholicbeverage@3x.54770622.png";